export function getProfileEditSectionForMissingFields(userType, missingFields) {
  if (!missingFields || missingFields.length === 0) return null;

  const firstMissing = missingFields[0];

  if (userType === 'brand') {
    if (['full_name'].includes(firstMissing)) {
      return 'personal';
    }
    if (['brand_logo_url', 'banner_picture'].includes(firstMissing)) {
      return 'images';
    }
    if (['about', 'company_name', 'company_description', 'annual_revenue'].includes(firstMissing)) {
      return 'company';
    }
    if (['influencer_categories', 'campaign_types'].includes(firstMissing)) {
      return 'marketing';
    }
    return 'company';
  }

  if (['full_name', 'tiktok_handle', 'street_address', 'city', 'state', 'zip_code'].includes(firstMissing)) {
    return 'personal';
  }
  if (['profile_picture_url', 'portfolio_images_urls'].includes(firstMissing)) {
    return 'images';
  }
  if (['content_deliverables', 'content_categories'].includes(firstMissing)) {
    return 'content';
  }
  if (['fee_models', 'short_video_rates', 'livestream_rates'].includes(firstMissing)) {
    return 'rates';
  }
  return 'personal';
}

export function navigateToProfileCompletion(navigate, userType, missingFields) {
  const section = getProfileEditSectionForMissingFields(userType, missingFields);

  if (userType === 'brand' && section === 'personal') {
    navigate('/dashboard/settings?edit=personal');
    return;
  }

  const profilePath = '/dashboard/profile';

  if (section) {
    navigate(`${profilePath}?edit=${section}`);
  } else {
    navigate(profilePath);
  }
}
